import { EXECUTION_PART_HEADERS } from '../../../constants/maintenance.constants';
import type { ExecutionPeriodTable } from '../../../utils/maintenanceExecutionMapper';
import { SimpleDataTable } from '../SimpleDataTable/SimpleDataTable';

export interface ExecutionTableProps {
	data: ExecutionPeriodTable;
}

const EMPTY = '—';

const numberFormatter = new Intl.NumberFormat('pt-BR', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const formatNumber = (value: number | null | undefined) => {
	if (value == null || !Number.isFinite(value)) return EMPTY;
	return numberFormatter.format(value);
};

const COLUMNS = [
	{ key: 'date', label: 'DATA' },
	{ key: 'fertilizer', label: 'FERTILIZANTE' },
	{ key: 'quantity', label: 'QUANTIA' },
	...EXECUTION_PART_HEADERS.map((header, index) => ({
		key: `part-${index}`,
		label: header,
	})),
	{ key: 'total', label: 'TOTAL' },
];

export const ExecutionTable = ({ data }: ExecutionTableProps) => {
	const rows = [
		...data.groups.flatMap((group) =>
			group.lines.map((line, lineIndex) => ({
				id: `${group.date}-${line.fertilizer}-${lineIndex}`,
				cells: {
					date: lineIndex === 0 ? group.date : '',
					fertilizer: line.fertilizer,
					quantity: formatNumber(line.quantity),
					...Object.fromEntries(
						line.parts.map((part, partIndex) => [`part-${partIndex}`, formatNumber(part)])
					),
					total: formatNumber(line.total),
				},
			}))
		),
		{
			id: 'period-total',
			isTotal: true,
			cells: {
				date: '',
				fertilizer: 'Total do período',
				quantity: formatNumber(data.totals.quantity),
				...Object.fromEntries(
					data.totals.parts.map((part, index) => [`part-${index}`, formatNumber(part)])
				),
				total: formatNumber(data.totals.total),
			},
		},
	];

	return <SimpleDataTable columns={COLUMNS} rows={rows} minWidth="56rem" />;
};
